/* eslint-disable */
export const user = {
  id    : 'cfaad35d-07a3-4447-a6c3-d8c3d54fd5df',
  name  : 'Daniel Sebők',
  email : 'daniel.sebok@optimaster.eu',
  avatar: 'assets/images/avatars/default.png',
  status: 'online'
};